import './i18n'; // import i18n first to initialize early
import React from 'react';
import ReactDOM from 'react-dom/client';
// Bundled with the build — the LAN server has no internet, so no font CDN.
import '@fontsource-variable/inter';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Now localStorage set after imports, no ESLint errors
// Replace your current localStorage check with:

// Suppress ResizeObserver loop errors (harmless React rendering artifacts)
const resizeObserverErrSuppressor = (e: ErrorEvent) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
    return true;
  }
  return false;
};
window.addEventListener('error', resizeObserverErrSuppressor);

// Prevent scroll-to-increment on number inputs (ERP data integrity protection)
// Pharmaceutical ERP requires deliberate data entry - accidental scroll changes
// violate GMP ALCOA+ data integrity principles and create audit trail pollution
document.addEventListener('wheel', (e: WheelEvent) => {
  const target = e.target as HTMLElement;
  if (target.tagName === 'INPUT' && (target as HTMLInputElement).type === 'number') {
    // Only prevent if the input is focused (active element)
    if (document.activeElement === target) {
      e.preventDefault();
    }
  }
}, { passive: false });

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
